/**
 * Qué se puede mostrar de un documento en el visor, y la respuesta de
 * `GET /documents/{id}/preview`. Va aparte de los componentes porque lo usan
 * dos (`VisorDocumento` y `DocumentPreview`) y el fast refresh de Vite exige
 * que un archivo de componentes exporte solo componentes.
 */

export interface PreviewResponse {
  url: string
  filename: string
  mime_type: string
}

export function isImage(mime: string, filename: string) {
  return mime.startsWith('image/') || /\.(png|jpe?g|webp|gif|heic|tiff?)$/i.test(filename)
}

export function isPdf(mime: string, filename: string) {
  return mime === 'application/pdf' || /\.pdf$/i.test(filename)
}

export function isAudio(mime: string, filename: string) {
  return mime.startsWith('audio/') || /\.(ogg|opus|mp3|m4a|aac|amr|wav)$/i.test(filename)
}

export function isVideo(mime: string, filename: string) {
  return mime.startsWith('video/') || /\.(mp4|3gp|mov)$/i.test(filename)
}
